<template>
  <div>
    <b-row align-h="center" id="item_photos" class="ml-1 mt-5">
      <b-col lg="4" sm="6" class="pb-2">
        <p class="text-center fs-18 font-weight-bold text-primary">Subir imágenes</p>
        <small class="text-center text-secondary ml-2">Subir imágenes: jpg, jpeg, png</small>
        <ImageUploader @photo-added="createPhoto" @preview-generated="generatePreview" />
      </b-col>
      <b-col lg="8" sm="6">
        <PhotoGallery
          v-if="images.length > 0"
          :photos="images"
          :cover-photo-id="coverPhotoId"
          @delete-photo="deletePhoto"
          @update-cover="updateCoverPhoto"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PhotoGallery from '../../shared/PhotoGallery'
import ImageUploader from '../../shared/ImageUploader'
import Button from '../../shared/Button'


export default {
  name: 'ItemImages',
  components: { PhotoGallery, ImageUploader, Button},
  props: {
    productId: {
      type: Number,
      required: true
    },
    coverPhotoId: {
      type: Number,
      required: false
    },
    images: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      processing: false
    }
  },
  methods: {
    createPhoto (form) {
      if (this.processing) { return }
      this.processing = true
      this.$http.post(`/api/production/products/${this.productId}/photos`, {
        photo: form
      })
        .then((res) => {
          const createdPhoto = res.data.photo
          createdPhoto.img_url = this.storedPreview
          createdPhoto.img_url_lg = this.storedPreview
          this.$emit('add-photo', createdPhoto)
        })
        .catch(e => {
          // console.log(e)
          this.$emit('display-alert', {
            message: 'No fue posible crear la imagen, imágenes válidas (.jpg, .jpeg, .png), máximo 10MB',
            variant: 'danger'
          })
        })
        .finally(this.processing = false)
    },
    deletePhoto (id) {
      if (this.processing) { return }
      this.processing = true
      this.$http.delete(`/api/production/products/${this.productId}/photos/${id}`)
        .then((res) => {
          // console.log(res)
          this.$emit('delete-photo', res.data.photo.id)
        })
        .catch(e => {
          console.log(e)
          this.$emit('display-alert', {
            message: 'No fue posible eliminar la imagen',
            variant: 'danger'
          })
        })
        .finally(() => {
          this.processing = false
        })
    },
    generatePreview (preview) {
      this.storedPreview = preview
    },
    updateCoverPhoto (id) {
      if (this.processing) { return }
      this.processing = true
      this.$http.patch(`/api/production/products/${this.productId}`, {
        product: { cover_photo_id: id }
      })
        .then((resp) => {
          this.$emit('update-cover-photo', resp.data.cover_photo_id)
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.processing = false
        })
    }
  }
}
</script>